import { trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

export const PERSONALIZED_COLLECTION_TEST_NAME = 'HP_PersonalizedCatalogs_March2026';

export const trackPersonalizedCollectionTest = (): void => {
    trackAbTestV2Variant(PERSONALIZED_COLLECTION_TEST_NAME);
};
